// src/utils/PdfStyles.js
export const pdfStyles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px'
  },
  header: {
    textAlign: 'center',
    marginBottom: '30px',
    borderBottom: '2px solid #eee',
    paddingBottom: '20px'
  },
  title: {
    color: '#0d6efd',
    marginBottom: '5px'
  },
  subheader: {
    color: '#6c757d',
    margin: 0
  },
  section: {
    marginBottom: '30px'
  },
  sectionTitle: {
    color: '#495057',
    borderBottom: '1px solid #eee',
    paddingBottom: '10px',
    marginBottom: '20px'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '15px',
    marginBottom: '20px'
  },
  label: {
    margin: '5px 0',
    color: '#6c757d'
  },
  value: {
    margin: '5px 0',
    fontWeight: '500'
  },
  amountBox: {
    backgroundColor: '#f8f9fa',
    padding: '20px',
    borderRadius: '8px',
    marginTop: '20px',
    textAlign: 'center'
  },
  amount: {
    margin: '0',
    fontSize: '28px',
    fontWeight: '600'
  },
  amountLabel: {
    margin: '0 0 10px 0',
    color: '#6c757d'
  },
  transactionType: {
    margin: '10px 0 0 0',
    color: '#6c757d',
    fontSize: '14px'
  },
  footer: {
    marginTop: '40px',
    paddingTop: '20px',
    borderTop: '1px solid #eee',
    color: '#6c757d',
    fontSize: '14px',
    textAlign: 'center'
  },
  footerNote: {
    margin: '5px 0',
    fontSize: '12px'
  }
};